import Swiper, {Pagination} from "swiper/core";
Swiper.use([Pagination]);

export function InitSliders() {
	const swiperSliders = document.querySelectorAll('.swiper-container');
	if (swiperSliders.length === 0) return;

	swiperSliders.forEach((slider) => {
		let options = {
			slidersPerView: 1,
			spaceBetween: 20,
		};

		if (slider.classList.contains('three-dotted')) {
			Object.assign(options, {
				breakpoints: {
					768: {
						slidesPerView: 3,
					},
					1024: {
						slidesPerView: 4,
						spaceBetween: 30,
					}
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
					dynamicBullets: true,
					dynamicMainBullets: 3
				}
			});
		}

		if (slider.classList.contains('full-page')) {
			Object.assign(options, {
				breakpoints: {
					768: {
						slidesPerView: 2,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 30,
					}
				}
			})
		}

		const swiper = new Swiper(slider, options);
	});
}

